<div class="ui container" appMargin appPadding paddingB="30">
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="20px">
        <!-- <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div> -->
        <div class="equipment-id">
          <!-- Title -->
          <!-- <span class="sub-item">Settings / Manage Workflow</span> -->
          <h2 class="ui primary header">Registered Companies</h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <!-- <button class="ui small  basic icon blue button" (click)="deleteMulti()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="remove selected user">
						<i class="trash icon"></i>
						</button>
						 <button class="ui small  primary  button" (click)="addCompany()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="add new company">
							Add New Company
							</button> -->
      </div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <!-- </div> -->
    <div class="ui divider" appMargin marginY="3"></div>
    <sui-message class="success" *ngIf="success">
      <div class="header">
        {{ success }}
      </div>
    </sui-message>
    <sui-message class="warning" *ngIf="error">
      <div class="header">
        {{ error | json }}
      </div>
    </sui-message>
  </div>

  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <!-- </div> -->
  <div
    fxLayout="row"
    appMargin
    class="ui segment"
    marginB="3"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
    id="dark"
  >
    <div fxFlex="3%">
      <sui-checkbox> </sui-checkbox>
    </div>
    <div fxFlex="10%">COMPANY NAME</div>
    <div fxFlex="10%">COMPANY TYPE</div>
    <div fxFlex="10%">OWNERSHIP TYPE</div>
    <div fxFlex="10%">VERIFICATION STATUS</div>
    <div fxFlex="10%">ADDED BY</div>
    <div fxFlex="10%">DATE ADDED</div>
    <div fxFlex="10%">STATUS</div>
    <div fxFlex="25%"></div>
  </div>

  <div
    class="ui segment"
    *ngFor="let workflow of workflows"
    appMargin
    marginB="3"
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
  >
    <div fxFlex="3%">
      <sui-checkbox> </sui-checkbox>
    </div>
    <div fxFlex="10%">{{ workflow?.action_performed }}</div>
    <div fxFlex="10%">{{ workflow?.actionBy }}</div>
    <div fxFlex="10%">{{ workflow?.table_name }}</div>
    <div fxFlex="10%">
      <span class="ui yellow label">{{ workflow?.schema_name }}</span>
    </div>
    <div fxFlex="10%">{{ workflow?.schema_name }}</div>
    <div fxFlex="10%">{{ workflow?.dateCreated }}</div>
    <div fxFlex="10%">
      <span class="ui green label">ACTIVE</span>
      <!-- <button class="ui circular tiny button" (click)="viewChangeField(workflow)"><i class="eye icon"></i></button> -->
    </div>
    <div fxFlex="25%" class="text-right">
      <div class="ui small basic primary dropdown button" suiDropdown>
        <div class="text">Actions</div>
        <i class="dropdown icon"></i>
        <div class="left menu" suiDropdownMenu>
          <a
            class="item"
            routerLink="/admin/companies/registered-company/{{ workflow?.id }}"
            >Company Details</a
          >
          <div class="item" (click)="deactivateCompany(workflow)">
            Deactivate Company
          </div>
          <div class="item" (click)="serviceAccess(workflow)">
            Service Access
          </div>
          <!-- <div class="item" (click)="chatCompany(workflow)">
            Chat with Company
          </div> -->
          <div class="item" (click)="verifyCompany(workflow)">
            Verify Company
          </div>
        </div>
      </div>
      &nbsp;
      <button class="ui circular tiny button">
        <div class="icon-container">
          <i class="comment alternate outline icon"></i>
          <div class="floating ui red label mini circular" style="color: #fff">
            11
          </div>
        </div>
      </button>
      <button class="ui circular tiny button" (click)="viewCompany(workflow)">
        <i class="eye icon"></i>
      </button>
    </div>
  </div>

  <div class="ui vertical basic segment">
    <div class="ui two column grid">
      <div class="column middle aligned">
        <div class="ui icon small button">
          <i class="database icon"></i>
        </div>
        <a class="ui basic label">{{ totalItems }} Record(s)</a>
      </div>
      <div
        class="column right aligned pagination menu"
        style="margin-left: auto"
      >
        <sui-pagination
          class="small"
          [collectionSize]="totalItems"
          [pageSize]="rows"
          [maxSize]="maxSize"
          [hasEllipses]="false"
          [page]="currentPage"
          (pageChange)="nextPage($event)"
        >
        </sui-pagination>
      </div>
    </div>
  </div>
</div>
